module.exports = __webpack_public_path__ + "static/media/15_before.46f65642.jpg";